import { duration as momduration, locale as momlocale, unix as momunix } from 'moment'

export class DateTimeService {

  static formatUnixTimestamp(ts: number, format = 'dd, DD.MM.YYYY, HH:mm', locale = 'de'): string {
    momlocale(locale)
    const creationMoment = momunix(ts)

    return creationMoment.format(format)
  }

  static humanizeTimestamp(ts: number, longDate: boolean = false, locale: string = 'de'): string {
    momlocale(locale)
    const creationMoment = momunix(ts)

    // @ts-ignore
    if (creationMoment.isSame(momunix(Date.now() / 1000), 'day') && Math.abs(creationMoment.diff()) <= 1000 * 60 * 60) {
      // @ts-ignore
      return momduration(creationMoment.diff()).humanize()
    }

    return longDate ? creationMoment.format('DD.MM.YYYY, HH:mm') : creationMoment.format('HH:mm')
  }

  static unixTimestamp() {
    return Math.round((new Date()).getTime() / 1000)
  }
}
